import * as React from "react";
import { GeneralModal } from "../Common/GeneralModal/GeneralModal";
import { CreateTransfer } from "./Steps/Step1";

import { AirWallexNewTransfer } from "./Steps/Step2_2";
import { RecipientSummaryConfirmDetails } from "./Steps/Step3_2";
import { SuccessAddRecipientStep } from "./Steps/Step4_2";

import { SelectRecipient } from "./Steps/Step2_1";
import { NewTransfer } from "./Steps/Step3_1";
import { NewTransferConfirmDetails } from "./Steps/Step4_1";
import { SuccessNewTransferStep } from "./Steps/Step5_1";

import { ErrorStep } from "./Steps/ErrorStep";
import { drupalSettings } from "../../utils/config";
import { ScaVerify } from "../ScaAirwallex/ScaVerify";
import { addRecipientApi } from "../../api/api";
import { useLoader } from "../Common/GeneralLoader/GeneralLoaderProvider";

export function CreateTransferFlow() {
  const [step, setStep] = React.useState(1);
  const [flow, setFlow] = React.useState(null);
  const [open, setOpen] = React.useState(true);
  const [showCloseIcon, setShowCloseIcon] = React.useState(true);
  const [payload, setPayload] = React.useState({});
  const { showLoader, hideLoader } = useLoader();

  React.useEffect(() => {
    jQuery(".create-transfer-popup select").each(function (index, element) {
      const $select = jQuery(element);
      const $parent = $select.closest(".form--item");

      $select.select2({
        dropdownAutoWidth: true,
        dropdownParent: $parent,
        minimumResultsForSearch: Infinity,
        scrollAfterSelect: true,
      });
    });

    if (step == 5) {
      setShowCloseIcon(false);
    }
  }, [step]);

  const getStepComponent = (step, flow) => {
    if (flow == "new") {
      switch (step) {
        case -1.2:
          return <ErrorStep />;
        case 0.2:
          return (
            <SuccessAddRecipientStep
              setFlow={setFlow}
              setStep={setStep}
              payload={payload}
              setPayload={setPayload}
              setOpen={setOpen}
            />
          );
        case 1.2:
          return (
            <CreateTransfer
              setFlow={setFlow}
              setStep={setStep}
              payload={payload}
              setPayload={setPayload}
            />
          );
        case 2.2:
          return (
            <AirWallexNewTransfer
              setFlow={setFlow}
              setStep={setStep}
              payload={payload}
              setPayload={setPayload}
            />
          );
        case 3.2:
          // Always show summary first; add-recipient may return 403 → 3.22 (SCA), same as AddRecipientFlow 2.0 → 2.1
          return (
            <RecipientSummaryConfirmDetails
              setFlow={setFlow}
              setStep={setStep}
              payload={payload}
              setPayload={setPayload}
            />
          );
        // Transaction SCA after add-recipient API returns 403 (same pattern as AddRecipientFlow step 2.1)
        case 3.22:
          return (
            <ScaVerify
              key={3.22}
              scaSessionCode={payload?.scaSessionCode}
              setStep={setStep}
              payload={payload}
              setPayload={setPayload}
              onCancel={() => setOpen(false)}
              onVerificationSucceed={async (result) => {
                const requestPayload = payload?._addRecipientRequest;
                if (!requestPayload || !result?.token) {
                  setStep(-1.2);
                  return;
                }
                showLoader();
                try {
                  const response = await addRecipientApi(requestPayload, {
                    scaToken: result.token,
                  });
                  if (response?.result) {
                    setPayload((prev) => ({
                      ...prev,
                      recipientId: response?.beneficiary_id,
                    }));
                    setStep(5.2);
                  } else {
                    setStep(-1.2);
                  }
                } catch {
                  setStep(-1.2);
                } finally {
                  hideLoader();
                }
              }}
              onVerificationFailed={() => setStep(-1.2)}
            />
          );
        case 5.2:
          return (
            <SuccessAddRecipientStep
              setFlow={setFlow}
              setStep={setStep}
              payload={payload}
              setPayload={setPayload}
              setOpen={setOpen}
            />
          );
      }
    } else if (flow == "stored") {
      switch (step) {
        case -1.1:
          return <ErrorStep />;
        case 0.1:
          return (
            <SuccessNewTransferStep
              setStep={setStep}
              payload={payload}
              setPayload={setPayload}
            />
          );
        case 1.1:
          return (
            <CreateTransfer
              setFlow={setFlow}
              setStep={setStep}
              payload={payload}
              setPayload={setPayload}
            />
          );
        case 2.1:
          return (
            <SelectRecipient
              setFlow={setFlow}
              setStep={setStep}
              payload={payload}
              setPayload={setPayload}
            />
          );
        case 3.1:
          return (
            <NewTransfer
              setFlow={setFlow}
              setStep={setStep}
              payload={payload}
              setPayload={setPayload}
            />
          );
        case 4.1:
          return (
            <NewTransferConfirmDetails
              setFlow={setFlow}
              setStep={setStep}
              payload={payload}
              setPayload={setPayload}
            />
          );
      }
    } else {
      return (
        <CreateTransfer
          setFlow={setFlow}
          setStep={setStep}
          payload={payload}
          setPayload={setPayload}
        />
      );
    }
  };

  const disableModal = drupalSettings?.options?.disableModal ?? false;
  const modalClassName =
    step == 0.1 || step == 0.2
      ? `create-transfer-popup has-success ${disableModal ? "no-modal" : ""}`
      : step == -1.1 || step == -1.2
        ? `create-transfer-popup has-error ${disableModal ? "no-modal" : ""}`
        : `create-transfer-popup step-${String(step).replace(".", "-")} ${disableModal ? "no-modal" : ""}`;

  const content = getStepComponent(step, flow);

  if (disableModal) {
    return <div className={modalClassName}>{content}</div>;
  }

  return (
    <GeneralModal
      open={open}
      setOpen={setOpen}
      showCloseIcon={showCloseIcon}
      className={modalClassName}
    >
      {content}
    </GeneralModal>
  );
}
